export default __webpack_public_path__ + "static/media/wallet05.5ac4c793.png";